import CsTable from "./cs-table";
export default CsTable;
